module.exports = __webpack_public_path__ + "static/media/warning-danger.4f3e78ec.svg";